/* The visual Shopify page owns the decision; EasySell remains the order editor. */
(() => {
  'use strict';

  const section = document.querySelector('.vl-upsell[data-section-id]');
  if (!section) return;

  const STORAGE_KEY = 'vl_postpurchase_upsell_v2';
  const PRODUCT_ID = '11564047696213';
  const SKU = 'BANDAS-24345';
  const PRICE_CENTS = 1199;
  const status = section.querySelector('[data-vl-upsell-status]');
  const buttons = section.querySelectorAll('[data-vl-upsell-accept], [data-vl-upsell-decline]');
  const isOrderFlow = new URLSearchParams(location.search).get('vl_upsell') === '1' && window.top === window;
  let record = null;
  let decided = false;
  let timer;

  try {
    if (isOrderFlow) record = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
  } catch (_) { /* A missing session can never create an order. */ }

  function save() {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  }

  function disableButtons() {
    buttons.forEach(button => { button.disabled = true; });
  }

  function finish(useOrderStatus = false) {
    clearTimeout(timer);
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) { /* Navigation still proceeds. */ }
    const target = useOrderStatus && record.orderStatusUrl ? record.orderStatusUrl : record.confirmationUrl;
    location.replace(target);
  }

  async function finalizePending(offers) {
    const endpoint = offers ? 'upsells' : 'funnels/reject';
    const payload = offers
      ? { shop: record.shop, currency: record.currency, funnel: record.funnelId, hash: record.hash, offers }
      : { shop: record.shop, hash: record.hash, pending_order: true };
    const response = await fetch(`https://quick2.tyslo.com/order/${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
    const result = await response.json();
    if (!response.ok || result?.success !== true || !result.order?.id) {
      throw new Error('EasySell no confirmó el pedido final.');
    }
    record.orderId = String(result.order.id);
    record.orderStatusUrl = result.order.order_status_url || null;
    return result;
  }

  async function accept() {
    const offerResponse = await fetch(`/products/${encodeURIComponent(record.productHandle)}.js`, {
      credentials: 'same-origin', cache: 'no-store'
    });
    if (!offerResponse.ok) throw new Error('No se pudo verificar el producto.');
    const product = await offerResponse.json();
    const variant = product.variants?.find(item => item.sku === SKU);
    if (String(product.id) !== PRODUCT_ID || !variant || !variant.available) throw new Error('Producto no disponible.');
    if (record.discount?.type !== 'fixed_amount' || Number(record.discount.value) !== 3) throw new Error('Descuento diferente.');
    const price = Number(variant.price);
    const discountAmount = 3;
    const total = (price - discountAmount * 100) / 100;
    if (price !== 1499 || Math.round(total * 100) !== PRICE_CENTS) throw new Error('Precio diferente.');

    const attemptKey = `vl_upsell_attempt_${record.orderId || record.hash}`;
    const claimAttempt = () => {
      if (localStorage.getItem(attemptKey)) throw new Error('El añadido ya se ha intentado.');
      localStorage.setItem(attemptKey, String(Date.now()));
      record.status = 'accepting';
      save();
    };
    if (navigator.locks?.request) {
      await navigator.locks.request(`vl-upsell-${record.orderId || record.hash}`, claimAttempt);
    } else {
      claimAttempt();
    }
    const controller = new AbortController();
    const abortTimer = setTimeout(() => controller.abort(), 45000);
    try {
      if (record.pendingOrder) {
        await finalizePending([{
          id: record.offerId,
          total,
          price: price / 100,
          product_id: product.id,
          variant_id: variant.id,
          quantity: 1,
          discount_amount: discountAmount,
          taxLines: null
        }]);
      } else {
        const response = await fetch('https://quick2.tyslo.com/order/funnels/accept', {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain', Accept: 'application/json' },
          body: JSON.stringify({
            shop: record.shop,
            variant: variant.id,
            currency: record.currency,
            funnel: record.funnelId,
            offer: record.offerId,
            discount_amount: discountAmount,
            quantity: 1,
            total,
            graphql_id: record.graphqlId,
            hash: record.hash,
            pending_order: false
          }),
          signal: controller.signal
        });
        const result = await response.json();
        if (!response.ok || result?.success !== true) throw new Error('EasySell no confirmó el añadido.');
      }
      record.status = 'accepted';
      save();
      status.textContent = 'Pack añadido. Te llevamos a la confirmación.';
      finish();
    } finally {
      clearTimeout(abortTimer);
    }
  }

  async function rejectPending() {
    const attemptKey = `vl_upsell_attempt_${record.hash}`;
    if (localStorage.getItem(attemptKey)) throw new Error('Ya se ha intentado cerrar este pedido.');
    localStorage.setItem(attemptKey, String(Date.now()));
    record.status = 'declining';
    save();
    await finalizePending(null);
    record.status = 'declined';
    save();
    finish();
  }

  function onUncertainResult() {
    status.textContent = 'Estamos terminando tu pedido. Si sales de esta página, EasySell lo finalizará automáticamente.';
    if (record.pendingOrder) {
      setTimeout(() => finish(), Math.max(0, record.createdAt + 11 * 60 * 1000 - Date.now()));
    } else {
      setTimeout(() => finish(true), 5000);
    }
  }

  function choose(action) {
    if (decided) return;
    if (!record || ![2, 3].includes(record.version) || !record.confirmationUrl || (record.pendingOrder ? !record.hash : !record.orderId || !record.orderStatusUrl)) {
      status.textContent = 'Esta oferta se activa justo después de confirmar el pedido.';
      return;
    }
    if (record.pendingOrder && Date.now() >= record.createdAt + 9 * 60 * 1000) {
      action = 'decline';
    }
    decided = true;
    disableButtons();
    clearTimeout(timer);
    if (action === 'decline') {
      status.textContent = '';
      if (record.pendingOrder) rejectPending().catch(onUncertainResult);
      else {
        record.status = 'declined';
        save();
        finish();
      }
      return;
    }
    status.textContent = '';
    accept().catch(onUncertainResult);
  }

  section.querySelectorAll('[data-vl-upsell-accept]').forEach(button => button.addEventListener('click', () => choose('accept')));
  section.querySelectorAll('[data-vl-upsell-decline]').forEach(button => button.addEventListener('click', () => choose('decline')));

  if (!record || ![2, 3].includes(record.version) || (record.pendingOrder ? !record.hash : !record.orderId)) return;
  if (record.status !== 'pending') {
    disableButtons();
    status.textContent = 'Tu pedido está guardado. Te llevamos al resumen.';
    if (record.pendingOrder && !record.orderId) {
      setTimeout(() => finish(), Math.max(0, record.createdAt + 11 * 60 * 1000 - Date.now()));
    } else {
      setTimeout(() => finish(record.status === 'accepting'), 1500);
    }
    return;
  }
  timer = setTimeout(() => choose('decline'), Math.max(0, record.deadline - Date.now()));
})();
